// src/scripts/interactionUtils.js
/**
 * Client-side quiz grading. Mirrors the backend's recomputation in
 * helpers/interactions.py; the backend remains authoritative for the
 * summary sent to the tutor.
 */
export function gradeQuiz(questions, answers) {
  const missed = [];
  let score = 0;
  let answeredCount = 0;
  // Reloaded chats read the interaction from a client-writable RTDB node, so
  // guard against corrupted or tampered payloads rather than throwing mid-render.
  const safeQuestions = Array.isArray(questions) ? questions : [];
  const safeAnswers = Array.isArray(answers) ? answers : [];
  safeQuestions.forEach((question, index) => {
    if (!question || typeof question !== "object") return;
    const selectedIndex = safeAnswers[index];
    // -1 is the stored unanswered sentinel; null/undefined are live state
    if (selectedIndex === null || selectedIndex === undefined || selectedIndex === -1) return;
    answeredCount++;
    if (selectedIndex === question.correctIndex) {
      score++;
    } else {
      const options = Array.isArray(question.options) ? question.options : [];
      missed.push({
        index,
        prompt: question.prompt,
        selectedLabel: options[selectedIndex],
        correctLabel: options[question.correctIndex],
      });
    }
  });
  return { score, answeredCount, total: safeQuestions.length, missed };
}
